import React, { useState } from "react";
import "./proficiency.css";
import bootstrap from "./ProficiencyResources/bootstrap-5-1.svg";
import css from "./ProficiencyResources/css-3.svg";
import sass from "./ProficiencyResources/sass-1.svg";
import html from "./ProficiencyResources/html-1.svg";
import react from "./ProficiencyResources/react-2.svg";
import typescript from "./ProficiencyResources/typescript.svg";
import javascript from "./ProficiencyResources/logo-javascript.svg";
import nodejs from "./ProficiencyResources/nodejs-icon.svg";
import express from "./ProficiencyResources/express-109.svg";
import tailwind from "./ProficiencyResources/tailwind-css-2.svg";
import { FaSchool, FaPeopleArrows } from "react-icons/fa";
import { Link } from "react-router-dom";
import {
  faGraduationCap,
  faCloudDownloadAlt,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import resumePDF from "./resume.pdf";
import Swal from "sweetalert2";

function Proficiency() {
  const [experienceButton, setExperienceButton] = useState(true);
  const [educationButton, setEducationButton] = useState(false);

  function showExperience() {
    setExperienceButton(true);
    setEducationButton(false);
    if (experienceButton === true) {
      const Toast = Swal.mixin({
        toast: true,
        position: {
          top: 50,
          left: 100,
        },
        showConfirmButton: false,
        timer: 1000,
        timerProgressBar: true,
        background: "#fff",
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", Swal.stopTimer);
          toast.addEventListener("mouseleave", Swal.resumeTimer);
        },
      });

      Toast.fire({
        icon: "success",
        title: "Already Viewing my Experience",
      });
    }
  }

  function showEducation() {
    setExperienceButton(false);
    setEducationButton(true);
    if (educationButton === true) {
      const Toast = Swal.mixin({
        toast: true,
        position: {
          top: 50,
          left: 100,
        },
        showConfirmButton: false,
        timer: 1000,
        timerProgressBar: true,
        background: "#fff",
        className: "my-toast",
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", Swal.stopTimer);
          toast.addEventListener("mouseleave", Swal.resumeTimer);
        },
      });

      Toast.fire({
        icon: "success",
        title: "Already Viewing my Education",
      });
    }
  }

  const downloadResume = () => {
    window.location.href = resumePDF;
  };

  const icons = [
    { src: css, alt: "CSS" },
    { src: sass, alt: "Sass" },
    { src: html, alt: "HTML" },
    { src: react, alt: "React" },
    { src: typescript, alt: "TypeScript" },
    { src: javascript, alt: "JavaScript" },
    { src: nodejs, alt: "Node.js" },
    { src: express, alt: "Express" },
    { src: bootstrap, alt: "Bootstrap" },
    { src: tailwind, alt: "Tailwind" },
  ];

  return (
    <div className="root-containersss">
      <div className="mt-4">
        <h2 className="text-center pt-3">Education & Experiences</h2>
        <h5 className="text-center mt-0 ">My Personal Journey</h5>
        <div className="container text-center d-flex justify-content-center align-items-center pt-3">
          <button
            className="my-btns btn btn-secondary mx-2"
            onClick={showExperience}
          >
            <FaPeopleArrows /> Experience
          </button>
          <button
            className="my-btns btn btn-secondary mx-2 px-2"
            onClick={showEducation}
          >
            <FaSchool /> Education
          </button>
        </div>
        <div className="my-journery container position-relative  my-5 rounded">
          <div class="container">
            <div class="row">
              {/* Education */}
              {educationButton && (
                <div class="col-md-12 col-lg-8 offset-lg-2">
                  <article class="education-item my-3">
                    <i class="education-icon fa fa-graduation-cap"></i>
                    <h3 class="education-date">
                      2024 <FontAwesomeIcon icon={faGraduationCap} />
                    </h3>
                    <div class="card">
                      <div class="card-body">
                        <h5 class="card-title">
                          <Link to={""}>SoftWare Engineer ALX SE</Link>
                        </h5>
                        <div class="card-text text-muted">2023 - 2024</div>
                        <div class="card-text">
                          <p>
                            In the ALX Software Engineering bootcamp, I'm
                            gaining a strong understanding of software
                            engineering concepts and developing the
                            problem-solving mindset necessary to tackle complex
                            challenges. The program emphasizes collaboration,
                            continuous learning, attention to detail, and time
                            management, preparing me to take on the challenges
                            of the industry with confidence.
                          </p>
                        </div>
                      </div>
                    </div>
                  </article>
                  <article class="education-item my-3">
                    <i class="education-icon fa fa-graduation-cap"></i>
                    <h3 class="education-date">
                      2023 <FontAwesomeIcon icon={faGraduationCap} />
                    </h3>
                    <div class="card">
                      <div class="card-body">
                        <h5 class="card-title">
                          <Link to={""}>Front End Developer (Self Taught)</Link>
                        </h5>
                        <div class="card-text text-muted">2021 - 2023</div>
                        <div class="card-text">
                          <p>
                            As a front-end developer, I specialize in using
                            JavaScript, React, and Bootstrap to create intuitive
                            and visually appealing user interfaces. My expertise
                            in these technologies enables me to deliver
                            responsive and user-friendly web applications,
                            showcasing my commitment to providing an exceptional
                            user experience in my portfolio.
                          </p>
                        </div>
                      </div>
                    </div>
                  </article>
                  <article class="education-item my-3">
                    <i class="education-icon fa fa-graduation-cap"></i>
                    <h3 class="education-date">
                      2019 <FontAwesomeIcon icon={faGraduationCap} />
                    </h3>
                    <div class="card">
                      <div class="card-body">
                        <h5 class="card-title">
                          <Link to={""}>BSc. in Information Technology</Link>
                        </h5>
                        <div class="card-text text-muted">2015 - 2019</div>
                        <div class="card-text">
                          <p>
                            As a graduate of South Eastern Kenya University with
                            a BSc in Information Technology, I have a strong
                            foundation in the fundamental principles of
                            information technology. My education has equipped me
                            with the skills and knowledge necessary to develop
                            innovative solutions to complex problems, and I am
                            committed to applying my expertise to create
                            impactful and meaningful software applications.
                          </p>
                        </div>
                      </div>
                    </div>
                  </article>
                  <article class="education-item my-3">
                    <i class="education-icon fa fa-graduation-cap"></i>
                    <h3 class="education-date">
                      2014 <FontAwesomeIcon icon={faGraduationCap} />
                    </h3>
                    <div class="card">
                      <div class="card-body">
                        <h5 class="card-title">
                          <Link to={""}>High School Degree</Link>
                        </h5>
                        <div class="card-text text-muted">2011 - 2014</div>
                        <div class="card-text">
                          <p>
                            As a graduate of high school in Kenya, I have a
                            solid educational background that has prepared me
                            for success in my academic and professional
                            pursuits. My high school education instilled in me a
                            strong work ethic, critical thinking skills, and a
                            passion for learning that I carry with me to this
                            day. I am proud of my educational achievements and
                            look forward to applying my skills and knowledge to
                            make a positive impact in the world.
                          </p>
                        </div>
                      </div>
                    </div>
                  </article>
                </div>
              )}
              {/* Experience */}
              {experienceButton && (
                <div class="col-md-12 col-lg-8 offset-lg-2 my-3">
                  <div class="timeline-block timeline-block-left">
                    <div class="marker">
                      <img src="" alt="" />
                    </div>
                    <div class="timeline-content">
                      <h3>Frontend Developer</h3>
                      <span>GipperPay Payments</span>
                      <div>
                      In my current position at GipperPay Payments, my responsibilities include developing user interfaces based on Figma designs and ensuring timely version updates. I am also accountable for integrating backend services with the frontend and collaborating closely with backend developers. In conjunction with other developers, our collective effort is focused on addressing UI issues to enhance the overall user experience.
                      </div>
                    </div>
                  </div>
                  <div class="timeline-block timeline-block-right">
                    <div class="marker"></div>
                    <div class="timeline-content">
                      <h3>Frontend Developer</h3>
                      <span>Freelancer</span>
                      <div>
                        <p>
                          In my current role as a freelancer front end
                          developer, I am responsible for developing and
                          maintaining the company's web application using React
                          and Redux. I work closely with the back-end team to
                          ensure seamless integration between the front-end and
                          back-end of the application. In addition to
                          implementing responsive design using CSS and
                          Bootstrap, I also assist in troubleshooting and
                          debugging any issues that may arise.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="timeline-block timeline-block-left">
                    <div class="marker"></div>
                    <div class="timeline-content">
                      <h3>IT Administrator</h3>
                      <span>Nimoli Medical Services</span>
                      <div>
                        <p>
                          One of my key responsibilities in this role was
                          maintaining and updating the hospital's website. I
                          worked with the marketing team to create new content
                          and optimize the website for search engines, which
                          resulted in a significant increase in website traffic
                          and patient inquiries. I also provided training to
                          staff on how to use the website and other IT systems,
                          which helped to improve overall efficiency within the
                          hospital.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="timeline-block timeline-block-right">
                    <div class="marker"></div>
                    <div class="timeline-content">
                      <h3>Store Manager</h3>
                      <span>Sweet Sweat Limited</span>
                      <div>
                        <p>
                          In my role as store manager at Sweet Sweat Company, I
                          was responsible for managing the daily operations of
                          the store. This included tasks such as inventory
                          management, customer service, and training and
                          supervising a team of employees. I also developed and
                          implemented marketing strategies to increase sales,
                          which resulted in a significant increase in revenue
                          for the store.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="timeline-block timeline-block-left">
                    <div class="marker"></div>
                    <div class="timeline-content">
                      <h3>Data Entry Clerk</h3>
                      <span>Biashara Sacco Society Limited</span>
                      <div>
                        <p>
                          One of the projects I worked on in this role was the
                          digitization of Sacco's records. I worked with the IT
                          team to scan and input all of the paper records into
                          the database, which greatly improved the efficiency
                          and accuracy of Sacco's record-keeping processes. I
                          also assisted in the creation of a new member portal,
                          which allowed members to access their account
                          information and make transactions online.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="container text-center">
          <button
            className="btn btn-secondary mb-4 my_resume_button border border-none" 
            onClick={downloadResume}
          >
            <FontAwesomeIcon icon={faCloudDownloadAlt} className="px-2" />
            My Resume
          </button>
        </div>
        <h2 className="text-center mx-5">
          My proficiency spans but not limited to :-
        </h2>
        <div className="language-icons container  h-25 mt-5 mb-5">
          {icons.map((icon) => (
            <img key={icon.alt} src={icon.src} alt={icon.alt} />
          ))}
        </div>
      </div>
    </div>
  );
}

export default Proficiency;
